import { render, staticRenderFns } from "./selectValEstado.vue?vue&type=template&id=3ffa0614&"
import script from "./selectValEstado.vue?vue&type=script&lang=js&"
export * from "./selectValEstado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports